import { call, put, select, takeLatest } from 'redux-saga/effects';
import { isSomething } from '../../utils/commonUtil';
import * as actions from '../../actions';
import {
  postDPORequest,
  postEmailRequestApi,
  checkAccountApi,
  checkOceanaAvailability,
} from './api';
import {
  DATA_COPY_SUBMIT_REQUEST,
  CLICK_EMAIL_US_REQUEST,
  CHECK_CHAT_AVAILABILITY_REQUEST,
  CHECK_ACCOUNT_REQUEST,
} from '../../types';
import {
  selectTeslaUrl,
  selectEnergySchedulingTeam,
  selectTroubleshootingGuide,
  selectContactUsOverrides,
} from './selectors';
import { oceanaConcernMap, oceanaRoutePointMap } from '../../utils/constants';
import { getEnergyChatConcernOverride } from '../../utils/energyChatUtils';

export function* dataCopyRequestSaga(action) {
  try {
    const { startDate, endDate, vin, locale } = action.payload;
    const { data } = yield call(postDPORequest, { startDate, endDate, vin }, locale);
    const { success, cerebroCode } = data;

    if (cerebroCode === 409) {
      yield put(actions.dataCopyDuplicate());
    } else if (success) {
      yield put(actions.dataCopySuccess());
    } else {
      yield put(actions.dataCopyFailure());
    }
  } catch (e) {
    if (e.response.status === 409) {
      yield put(actions.dataCopyDuplicate());
    } else {
      yield put(actions.dataCopyFailure());
    }
  }
}

export function* clickEmailUsRequestSaga(action) {
  try {
    const { files = [], additionalNote, categoryCode, symptomCode = '', locale } = action.payload;
    const data = {
      files,
      categoryCode,
      symptomCode, // we do not yet have a mapping from L2 to symptom code
      description: additionalNote,
    };

    yield call(postEmailRequestApi, data, locale);
    yield put(actions.clickEmailUsSuccess());
  } catch (e) {
    yield put(actions.clickEmailUsFailure());
  }
}

export function* checkChatAvailabilitySaga(action) {
  const { concernType, locale, secondChoice } = action.payload;
  const teslaUrl = yield select(selectTeslaUrl);
  const energySchedulingTeam = yield select(selectEnergySchedulingTeam);
  const troubleshootingGuide = yield select(selectTroubleshootingGuide);
  const contactUsOverrides = yield select(selectContactUsOverrides);
  const energyChatConcernOverride = getEnergyChatConcernOverride(
    troubleshootingGuide,
    energySchedulingTeam,
    contactUsOverrides
  );

  try {
    const body = {
      locale: locale.replace('_', '-').toLowerCase(),
      Concern: isSomething(energyChatConcernOverride)
        ? energyChatConcernOverride
        : oceanaConcernMap[secondChoice],
      ...oceanaRoutePointMap[concernType],
    };
    const { data } = yield call(checkOceanaAvailability, body, teslaUrl);
    if (
      data?.avayaPrerequisite?.is_queue_open === 'true' &&
      data?.avayaPrerequisite?.serviceMetricsResponseMap
    ) {
      yield put(
        actions.checkChatAvailabilitySuccess({
          chatWidgetParams: data.chatWidgetParams,
          serviceMetricsResponseMap: data.avayaPrerequisite.serviceMetricsResponseMap,
          startTime: data?.avayaPrerequisite?.open_time,
          endTime: data?.avayaPrerequisite?.close_time,
          timeZone: data?.avayaPrerequisite?.locale_timezone,
        })
      );
    } else {
      yield put(actions.checkChatAvailabilityFailure());
    }
  } catch (e) {
    yield put(actions.checkChatAvailabilityFailure());
  }
}

export function* checkAccountSaga() {
  const {
    Data: { locale },
  } = yield select();
  try {
    const {
      data: {
        success,
        data: { isAccountDeletable },
      },
    } = yield call(checkAccountApi, locale);

    if (success) {
      yield put(actions.checkAccountSuccess(isAccountDeletable));
    } else {
      yield put(actions.clickEmailUsFailure());
    }
  } catch (e) {
    yield put(actions.checkAccountFailure());
  }
}

const buttonRequestSagas = [
  takeLatest(DATA_COPY_SUBMIT_REQUEST, dataCopyRequestSaga),
  takeLatest(CLICK_EMAIL_US_REQUEST, clickEmailUsRequestSaga),
  takeLatest(CHECK_CHAT_AVAILABILITY_REQUEST, checkChatAvailabilitySaga),
  takeLatest(CHECK_ACCOUNT_REQUEST, checkAccountSaga),
];

export default buttonRequestSagas;
